import ColumnMatcherContainer from './ColumnMatcherContainer';

export default ColumnMatcherContainer;
